<template>
  <div id="app">
     <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {},
  data() {
    return {
      // user: JSON.parse(sessionStorage.getItem('CurUser'))  // 注释掉从sessionStorage获取用户信息
    }
  },
  mounted() {
    // 菜单状态恢复逻辑已移至路由守卫中处理
  }
}
</script>

<style>
  #app {
    height: 100%;
  }
</style>
